import { useState, FormEvent, useEffect } from "react";
import { setUser } from "../../store/slices/userSlice";
import { useAppDispatch } from "../../store/store";
import { login } from "../../api/auth";
import { setGeneralAlertMessage } from "../../store/slices/generalSlice";
import { setToken } from "../../utils/token";
import { AdminRole } from "../../types/adminRoles";
import { BrandLogo, BrushStrokes, Button, Field, Input } from "../../ui";
import "./styles.scss";

const Auth = () => {
  const dispatch = useAppDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await login({ email, password });
      const user = res.data.user;

      // Check if user has at least one admin role
      if (!user.adminRoles || user.adminRoles.length === 0) {
        dispatch(
          setGeneralAlertMessage({
            message: "Access denied. You don't have permission to access the dashboard.",
            type: "error",
          })
        );
        setIsLoading(false);
        return;
      }

      // Check if user ONLY has referee admin role
      const hasOnlyRefereeAdmin = user.adminRoles.every((role: AdminRole) => role === AdminRole.REFEREE_ADMIN);
      if (hasOnlyRefereeAdmin) {
        dispatch(
          setGeneralAlertMessage({
            message: "Access denied. You do not have dashboard access.",
            type: "error",
          })
        );
        setIsLoading(false);
        return;
      }

      setToken(res.data.token);
      dispatch(setUser({ user, token: res.data.token }));
    } catch (error: any) {
      dispatch(setGeneralAlertMessage({ message: error.message, type: "error" }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = "The Clash Egypt - Admin Dashboard";
  }, []);

  return (
    <div className="auth-container">
      <aside className="auth-brand-panel" aria-hidden="true">
        <BrandLogo className="auth-brand-logo" title="" />
        <p className="auth-brand-label">Admin Dashboard</p>
        <BrushStrokes placement="bottom-right" size={420} className="auth-brand-brush" />
      </aside>

      <div className="auth-band">
        <BrandLogo className="auth-band-logo" />
      </div>

      <main className="auth-admin-container">
        <div className="auth-admin-card">
          <h1 className="auth-admin-title">The Clash Egypt Admin Dashboard</h1>
          <p className="auth-admin-subtitle">Sign in to manage players, representers & tournaments</p>

          <form onSubmit={handleLogin} className="auth-form">

            <Field label="Email">
              {(id) => (
                <Input
                  id={id}
                  type="email"
                  placeholder="Email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              )}
            </Field>

            <Field label="Password">
              {(id) => (
                <Input
                  id={id}
                  type="password"
                  placeholder="Password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              )}
            </Field>

            <Button type="submit" variant="primary" size="lg" block loading={isLoading}>
              Login
            </Button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Auth;
